import React, { useContext } from 'react';
import { useLocation, useNavigation } from 'react-router-dom';
import LoadingIcon from '../loading_icon/loading_icon';
import logo from '../../images/odonto_secure_white_logo.png';
import { AuthContext, LoadingContext } from '../../contexts';
import {MenuItem, AccordionMenuItem, SubMenuItem} from './menu_items';
import * as routes from '../../constants/paths';
import * as permissions from '../../constants/permissions';
import './admin_frame.scss';


class AdminFrame extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuOpened: window.innerWidth > 970,
    };

    window.beforeToggleMenuCallbacks = new Set();
  }

  async componentDidMount() {
  }

  toggleMenu() {
    if(window.beforeToggleMenuCallbacks && window.beforeToggleMenuCallbacks.size) {
      for(let callback of window.beforeToggleMenuCallbacks) {
        callback(!this.state.menuOpened);
      }
    }

    this.setState({
      menuOpened: !this.state.menuOpened
    });
  }

  componentDidUpdate(prevProps) {
    if(this.props.location.pathname !== prevProps.location.pathname && this.state.menuOpened && window.innerWidth <= 970) {
      this.setState({
        menuOpened: false
      });
    }
  }

  isLoading() {
    return this.props.navigation.state === "loading" ||
           (this.props.navigation.state === "submitting" && this.props.navigation.formMethod !== 'delete');
  }

  getLoadingIconText() {
    switch (this.props.navigation.state) {
      case 'submitting':
        return 'Salvando';
      case 'loading':
      default:
        return 'Carregando';
    }
  }

  render() {
    return (
      <div className="admin-frame">

        <header className="admin-frame__header">

          <div className="admin-frame__header__content-wrapper">

            <div className="admin-frame__header__logo-container">

              <img className="admin-frame__header__logo" src={logo} alt="Logo da Odonto Secure" />
              <p className="admin-frame__header__logo-text">Odonto Secure</p>

            </div>

            <button
              className="admin-frame__header__menu-button"
              onClick={() => this.toggleMenu()}
            >

              <span className="admin-frame__header__menu-icon"></span>

            </button>

          </div>


          <div className="admin-frame__header__controls-wrapper">

            {/* {(this.props.auth.permission_ids.includes(permissions.TO_BE_DEFINED)) &&
              <Link
                className="admin-frame__header__counter-button"
                to={routes.TO_BE_DEFINED}
              >

                <i className="fas fa-user-plus"></i>

                <div className="admin-frame__header__counter-button__counter">

                  <p>{this.props.to_be_defined_count}</p>

                </div>

              </Link>
            } */}

            <div className="admin-frame__header__identifiers">

              <p className="admin-frame__header__user-name">{this.props.auth.username}</p>

            </div>

            <button
              className="admin-frame__header__logout-button"
              onClick={() => this.props.onLogout()}
            >

              <i className="fas fa-sign-out-alt"></i>

            </button>

          </div>

        </header>

        <div className="admin-frame__content-wrapper">

          <aside className={`admin-frame__menu${this.state.menuOpened ? '' : '--hidden'}`}>

            <ul className="admin-frame__menu__list">

              <MenuItem
                text="Área de trabalho"
                linkTo={routes.DESKTOP_PATH}
                location={this.props.location}
                icon={<i className="fas fa-home menu-items__default-item__icon"></i>}
              />

              {(this.props.auth.permission_ids.includes(permissions.VIEW_STAFF_PERMISSION) || this.props.auth.permission_ids.includes(permissions.ADD_STAFF_PERMISSION)) &&
                <AccordionMenuItem
                  text="Colaboradores"
                  icon={<i className="fas fa-users menu-items__accordion-item__icon"></i>}
                >

                  {this.props.auth.permission_ids.includes(permissions.VIEW_STAFF_PERMISSION) &&
                    <SubMenuItem
                      text="Listar colaboradores"
                      linkTo={routes.STAFF_LIST_PATH}
                      location={this.props.location}
                    />
                  }

                  {this.props.auth.permission_ids.includes(permissions.ADD_STAFF_PERMISSION) &&
                    <SubMenuItem
                      text="Adicionar colaborador"
                      linkTo={routes.STAFF_ADD_PATH}
                      location={this.props.location}
                    />
                  }

                </AccordionMenuItem>
              }

              {(this.props.auth.permission_ids.includes(permissions.VIEW_BASIC_DOCUMENT_PERMISSION) || this.props.auth.permission_ids.includes(permissions.MANAGE_DOCUMENT_PERMISSION)) &&
                <AccordionMenuItem
                  text="Documentos"
                  icon={<i className="fa-solid fa-file menu-items__accordion-item__icon"></i>}
                >

                  {this.props.auth.permission_ids.includes(permissions.VIEW_BASIC_DOCUMENT_PERMISSION) &&
                    <SubMenuItem
                      text="Listar documentos"
                      linkTo={routes.DOCUMENT_LIST_PATH}
                      location={this.props.location}
                    />
                  }

                  {this.props.auth.permission_ids.includes(permissions.MANAGE_DOCUMENT_PERMISSION) &&
                    <SubMenuItem
                      text="Adicionar documento"
                      linkTo={routes.DOCUMENT_ADD_PATH}
                      location={this.props.location}
                    />
                  }

                </AccordionMenuItem>
              }

              {(this.props.auth.permission_ids.includes(permissions.VIEW_BASIC_COMPLAINT_TYPE_PERMISSION) || this.props.auth.permission_ids.includes(permissions.MANAGE_COMPLAINT_TYPE_PERMISSION)) &&
                <AccordionMenuItem
                  text="Queixas"
                  icon={<i className="fa-solid fa-tag menu-items__accordion-item__icon"></i>}
                >

                  {this.props.auth.permission_ids.includes(permissions.VIEW_BASIC_COMPLAINT_TYPE_PERMISSION) &&
                    <SubMenuItem
                      text="Listar queixas"
                      linkTo={routes.COMPLAINT_TYPE_LIST_PATH}
                      location={this.props.location}
                    />
                  }

                  {this.props.auth.permission_ids.includes(permissions.MANAGE_COMPLAINT_TYPE_PERMISSION) &&
                    <SubMenuItem
                      text="Adicionar queixa"
                      linkTo={routes.COMPLAINT_TYPE_ADD_PATH}
                      location={this.props.location}
                    />
                  }

                </AccordionMenuItem>
              }

              {(this.props.auth.permission_ids.includes(permissions.VIEW_CLINIC_PERMISSION) || this.props.auth.permission_ids.includes(permissions.ADD_CLINIC_PERMISSION)) &&
                <AccordionMenuItem
                  text="Clientes"
                  icon={<i className="fa-solid fa-tooth menu-items__accordion-item__icon"></i>}
                >

                  {this.props.auth.permission_ids.includes(permissions.VIEW_CLINIC_PERMISSION) &&
                    <SubMenuItem
                      text="Listar clientes"
                      linkTo={routes.CLINIC_LIST_PATH}
                      location={this.props.location}
                    />
                  }

                  {this.props.auth.permission_ids.includes(permissions.ADD_CLINIC_PERMISSION) &&
                    <SubMenuItem
                      text="Adicionar cliente"
                      linkTo={routes.CLINIC_ADD_PATH}
                      location={this.props.location}
                    />
                  }

                </AccordionMenuItem>
              }

              {(this.props.auth.permission_ids.includes(permissions.VIEW_PATIENT_PERMISSION) || this.props.auth.permission_ids.includes(permissions.ADD_PATIENT_PERMISSION)) &&
                <AccordionMenuItem
                  text="Pacientes"
                  icon={<i className="fa-solid fa-hospital-user menu-items__accordion-item__icon"></i>}
                >

                  {this.props.auth.permission_ids.includes(permissions.VIEW_PATIENT_PERMISSION) &&
                    <SubMenuItem
                      text="Listar pacientes"
                      linkTo={routes.PATIENT_LIST_PATH}
                      location={this.props.location}
                    />
                  }

                  {this.props.auth.permission_ids.includes(permissions.ADD_PATIENT_PERMISSION) &&
                    <SubMenuItem
                      text="Adicionar paciente"
                      linkTo={routes.PATIENT_ADD_PATH}
                      location={this.props.location}
                    />
                  }

                </AccordionMenuItem>
              }

              {(this.props.auth.permission_ids.includes(permissions.VIEW_BASIC_COMPLAINT_CASE_PERMISSION) || this.props.auth.permission_ids.includes(permissions.ADD_COMPLAINT_CASE_PERMISSION)) &&
                <AccordionMenuItem
                  text="Casos"
                  icon={<i className="fa-solid fa-scale-balanced menu-items__accordion-item__icon"></i>}
                >

                  {this.props.auth.permission_ids.includes(permissions.VIEW_BASIC_COMPLAINT_CASE_PERMISSION) &&
                    <SubMenuItem
                      text="Listar casos"
                      linkTo={routes.COMPLAINT_CASE_LIST_PATH}
                      location={this.props.location}
                    />
                  }

                  {this.props.auth.permission_ids.includes(permissions.ADD_COMPLAINT_CASE_PERMISSION) &&
                    <SubMenuItem
                      text="Adicionar caso"
                      linkTo={routes.COMPLAINT_CASE_ADD_PATH}
                      location={this.props.location}
                    />
                  }

                </AccordionMenuItem>
              }
              {/* {this.props.auth.permission_ids.includes(permissions.VIEW_STAFF_PERMISSION) &&
                <ExpandableOrganizerMenuItem
                 text="Sistema"
                >


                </ExpandableOrganizerMenuItem>
              } */}

            </ul>

          </aside>

          <div
            className="admin-frame__content-blocker"
            onClick={() => this.toggleMenu()}
          />

          <main className="admin-frame__main">

            <LoadingContext.Provider value={{isLoading: this.isLoading()}}>

              {this.props.children}

            </LoadingContext.Provider>


            <div
              className={`admin-frame__loading-screen${this.isLoading() ? '' : '--hidden'}`}
              key="admin_frame:loading_screen"
            >

              <div className="admin-frame__loading-screen__wrapper">

                <div className="admin-frame__loading-screen__icon-wrapper">

                  <LoadingIcon 
                    className="admin-frame__loading-screen__icon" 
                    text={this.getLoadingIconText()}
                  />

                </div>

              </div>         

            </div>

          </main>

        </div>

        <footer className="admin-frame__footer">

          <p className="admin-frame__footer__text">{(new Date()).getFullYear()} © ODONTO SECURE</p>

        </footer>

      </div>
    );
  }
}

const WrappedAdminFrame = props => {
  const location = useLocation();
  const auth = useContext(AuthContext);
  const navigation = useNavigation();

  return (
    <AdminFrame
      location={location}
      auth={auth}
      navigation={navigation}
      {...props}
    />
  );
}

export {WrappedAdminFrame as AdminFrame};
